import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { VehicleSpecificInfoCardComponent } from './vehicle-specific-info-card.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
  ],
  declarations: [VehicleSpecificInfoCardComponent],
  exports:[VehicleSpecificInfoCardComponent]
})
export class VehicleSpecificInfoCardModule { }
